import { Route } from '@angular/router';

import { LayoutComponent } from './components/layout.component';
import { OryAuthPages } from './constants/pages.constant';
import { oryAuthGuard } from './guards/ory-auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { OtpVerifyComponent } from './pages/otp-verify/otp-verify.component';
import { RegisterComponent } from './pages/register/register.component';

export const oryAuthRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [oryAuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: OryAuthPages.LOGIN,
      },
      { path: OryAuthPages.LOGIN, component: LoginComponent },
      { path: OryAuthPages.REGISTER, component: RegisterComponent },
      { path: OryAuthPages.OTP, component: OtpVerifyComponent },
    ],
  },
];
